var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],attrs:{"align":"center","justify":"center"}},[_c('v-subheader',[_vm._v("Window Size")]),_vm._v(" "+_vm._s(_vm.windowSize)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }